/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { WebAppGetFragmentSocialUploadsUploadByIdQueryResponse, WebAppGetFragmentSocialUploadsUploadByIdPathParams, WebAppGetFragmentSocialUploadsUploadById401, WebAppGetFragmentSocialUploadsUploadById403 } from "../models/WebAppGetFragmentSocialUploadsUploadById";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { webAppGetFragmentSocialUploadsUploadById } from "../axios/webAppGetFragmentSocialUploadsUploadById";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const webAppGetFragmentSocialUploadsUploadByIdQueryKey = (uploadId: WebAppGetFragmentSocialUploadsUploadByIdPathParams["uploadId"]) => ["api-v2", { url: '/web-app/v1/fragment-social-uploads/:uploadId', params: {uploadId:uploadId} }] as const

export type WebAppGetFragmentSocialUploadsUploadByIdQueryKey = ReturnType<typeof webAppGetFragmentSocialUploadsUploadByIdQueryKey>

export function webAppGetFragmentSocialUploadsUploadByIdQueryOptions(uploadId: WebAppGetFragmentSocialUploadsUploadByIdPathParams["uploadId"], config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = webAppGetFragmentSocialUploadsUploadByIdQueryKey(uploadId)
        return queryOptions<WebAppGetFragmentSocialUploadsUploadByIdQueryResponse, ResponseErrorConfig<WebAppGetFragmentSocialUploadsUploadById401 | WebAppGetFragmentSocialUploadsUploadById403>, WebAppGetFragmentSocialUploadsUploadByIdQueryResponse, typeof queryKey>({
         enabled: !!(uploadId),
         queryKey,
         queryFn: async ({ signal }) => {
            return webAppGetFragmentSocialUploadsUploadById(uploadId, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary Get a single social upload by id
 * {@link /web-app/v1/fragment-social-uploads/:uploadId}
 */
export function useWebAppGetFragmentSocialUploadsUploadById<TData = WebAppGetFragmentSocialUploadsUploadByIdQueryResponse, TQueryData = WebAppGetFragmentSocialUploadsUploadByIdQueryResponse, TQueryKey extends QueryKey = WebAppGetFragmentSocialUploadsUploadByIdQueryKey>(uploadId: WebAppGetFragmentSocialUploadsUploadByIdPathParams["uploadId"], options: 
{
  query?: Partial<QueryObserverOptions<WebAppGetFragmentSocialUploadsUploadByIdQueryResponse, ResponseErrorConfig<WebAppGetFragmentSocialUploadsUploadById401 | WebAppGetFragmentSocialUploadsUploadById403>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...queryOptions } = queryConfig
         const queryKey = queryOptions?.queryKey ?? webAppGetFragmentSocialUploadsUploadByIdQueryKey(uploadId)
         

         const query = useQuery({
          ...webAppGetFragmentSocialUploadsUploadByIdQueryOptions(uploadId, config),
          queryKey,
          ...queryOptions
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<WebAppGetFragmentSocialUploadsUploadById401 | WebAppGetFragmentSocialUploadsUploadById403>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}